import { api } from './api';
import { ApiResponse } from '../types/api';
import { Market } from '../types/market';

export const marketService = {
  getAllMarkets: async (): Promise<Market[]> => {
    const res = await api.get<ApiResponse<Market[]>>('/api/admin/market');
    return res.data.data;
  },

  createMarket: async (data: Omit<Market, 'id' | 'createdAt' | 'updatedAt'>, imageFile?: File): Promise<void> => {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    if (imageFile) formData.append('image', imageFile);
    await api.post('/api/admin/market', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  updateMarket: async (id: number, data: Omit<Market, 'id' | 'createdAt' | 'updatedAt'>, imageFile?: File): Promise<void> => {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    if (imageFile) formData.append('image', imageFile);
    await api.put(`/api/admin/market/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },

  deleteMarket: async (id: number): Promise<void> => {
    await api.delete(`/api/admin/market/${id}`);
  },
};
